export const PROJECT_MILESTONE_TYPE__CUSTOM = 'custom';
export const PROJECT_MILESTONE_TYPE__SCHEDULED = 'scheduled';
export const PROJECT_MILESTONE_TYPE__CONDITIONAL = 'conditional';
export const PROJECT_MILESTONE_TYPE__CONSENT = 'consent';
export const PROJECT_MILESTONE_TYPE__EVENTS = 'clinical_events';

export const PROJECT_MILESTONE_TYPES = [
  PROJECT_MILESTONE_TYPE__CUSTOM,
  PROJECT_MILESTONE_TYPE__SCHEDULED,
  PROJECT_MILESTONE_TYPE__CONDITIONAL,
  PROJECT_MILESTONE_TYPE__CONSENT,
  PROJECT_MILESTONE_TYPE__EVENTS,
];

export const MILESTONE_DEPENDENCY_CONDITION__QUESTIONNAIRE_ASSIGNEES_COMPLETED =
  'questionnaireAssigneesCompleted';
export const MILESTONE_DEPENDENCY_CONDITION__ACTIVITY_COMPLETED =
  'activityCompleted';
export const MILESTONE_DEPENDENCY_CONDITIONS = [
  MILESTONE_DEPENDENCY_CONDITION__QUESTIONNAIRE_ASSIGNEES_COMPLETED,
  MILESTONE_DEPENDENCY_CONDITION__ACTIVITY_COMPLETED,
];

export const TRANSITION_CONDITION_TYPE__MESSAGE_TYPE_ONE_OF =
  'messageTypeOneOf';
export const TRANSITION_CONDITION_TYPE__NEW_VALUE_OF_CONTEXT_PROPERTY =
  'newValueOfContextProperty';

export const QUESTIONNAIRE_ASSIGNEE_TYPE__DOCTOR = 'DR';
export const QUESTIONNAIRE_ASSIGNEE_TYPE__CASE_MANAGER = 'CM';
export const QUESTIONNAIRE_ASSIGNEE_TYPE__PATIENT = 'PT';
export const QUESTIONNAIRE_ASSIGNEE_TYPE__SURVEYOR = 'SR';

export const QUESTIONNAIRE_ASSIGNEE_TYPE_OPTIONS = [
  {
    value: QUESTIONNAIRE_ASSIGNEE_TYPE__DOCTOR,
    label: 'forms:clinician.label',
  },
  {
    value: QUESTIONNAIRE_ASSIGNEE_TYPE__CASE_MANAGER,
    label: 'forms:caseManager.label',
  },
  {
    value: QUESTIONNAIRE_ASSIGNEE_TYPE__PATIENT,
    label: 'forms:patient.label',
  },
  // { value: QUESTIONNAIRE_ASSIGNEE_TYPE__SURVEYOR, label: 'Surveyor' },
];

export const QUESTIONNAIRE_ASSIGNEE_TYPE_VALUES = [
  QUESTIONNAIRE_ASSIGNEE_TYPE__DOCTOR,
  QUESTIONNAIRE_ASSIGNEE_TYPE__CASE_MANAGER,
  QUESTIONNAIRE_ASSIGNEE_TYPE__PATIENT,
  QUESTIONNAIRE_ASSIGNEE_TYPE__SURVEYOR,
];

export const MILESTONE_CLINICAL_EVENTS_TYPE__APPOINTMENTS = 'appointments';
export const MILESTONE_CLINICAL_EVENTS_TYPE__MEDICATIONS = 'medications';
export const MILESTONE_CLINICAL_EVENTS_TYPE__PATIENT_ENROLMENT =
  'patient_enrolment';
export const MILESTONE_CLINICAL_EVENTS_TYPE__PROCEDURES = 'procedures';

export const MILESTONE_CLINICAL_EVENTS_TYPE__VALUES = [
  MILESTONE_CLINICAL_EVENTS_TYPE__APPOINTMENTS,
  MILESTONE_CLINICAL_EVENTS_TYPE__MEDICATIONS,
  MILESTONE_CLINICAL_EVENTS_TYPE__PATIENT_ENROLMENT,
  MILESTONE_CLINICAL_EVENTS_TYPE__PROCEDURES,
];

export const MILESTONE_APPOINTMENTS_STATUS__BOOKED = 'booked';
export const MILESTONE_APPOINTMENTS_STATUS__CANCELLED = 'cancelled';
export const MILESTONE_APPOINTMENTS_STATUS__NOSHOW = 'no_show';
export const MILESTONE_APPOINTMENTS_STATUS__COMPLETED = 'completed';

export const MILESTONE_APPOINTMENTS_STATUS__VALUES = [
  MILESTONE_APPOINTMENTS_STATUS__BOOKED,
  MILESTONE_APPOINTMENTS_STATUS__CANCELLED,
  MILESTONE_APPOINTMENTS_STATUS__NOSHOW,
  MILESTONE_APPOINTMENTS_STATUS__COMPLETED,
];

export const MILESTONE_MEDICATIONS_STATUS__PRESCRIBED = 'prescribed';
export const MILESTONE_MEDICATIONS_STATUS__DISPENSED = 'dispensed';
export const MILESTONE_MEDICATIONS_STATUS__ADMINISTERED = 'administered';
export const MILESTONE_MEDICATIONS_STATUS__CANCELLED = 'cancelled';

export const MILESTONE_MEDICATIONS_STATUS__VALUES = [
  MILESTONE_MEDICATIONS_STATUS__PRESCRIBED,
  MILESTONE_MEDICATIONS_STATUS__DISPENSED,
  MILESTONE_MEDICATIONS_STATUS__ADMINISTERED,
  MILESTONE_MEDICATIONS_STATUS__CANCELLED,
];

export const MILESTONE_PROCEDURES_STATUS__BOOKED = 'booked';
export const MILESTONE_PROCEDURES_STATUS__CANCELLED = 'cancelled';
export const MILESTONE_PROCEDURES_STATUS__NOSHOW = 'no_show';
export const MILESTONE_PROCEDURES_STATUS__COMPLETED = 'completed';
export const MILESTONE_PROCEDURES_STATUS__ABORTED = 'aborted';

export const MILESTONE_PROCEDURES_STATUS__VALUES = [
  MILESTONE_PROCEDURES_STATUS__BOOKED,
  MILESTONE_PROCEDURES_STATUS__CANCELLED,
  MILESTONE_PROCEDURES_STATUS__NOSHOW,
  MILESTONE_PROCEDURES_STATUS__COMPLETED,
  MILESTONE_PROCEDURES_STATUS__ABORTED,
];

export const MILESTONE_APPOINTMENT_ANCHOR__START_TIME =
  'appointment_start_time';
export const MILESTONE_APPOINTMENT_ANCHOR__END_TIME = 'appointment_end_time';

export const MILESTONE_APPOINTMENT_ANCHOR__VALUES = [
  MILESTONE_APPOINTMENT_ANCHOR__START_TIME,
  MILESTONE_APPOINTMENT_ANCHOR__END_TIME,
];

export const MILESTONE_MEDICATION_ANCHOR__START_TIME = 'medication_start_time';
export const MILESTONE_MEDICATION_ANCHOR__END_TIME = 'medication_end_time';

export const MILESTONE_MEDICATION_ANCHOR__VALUES = [
  MILESTONE_MEDICATION_ANCHOR__START_TIME,
  MILESTONE_MEDICATION_ANCHOR__END_TIME,
];

export const MILESTONE_PROCEDURE_ANCHOR__START_TIME = 'procedure_start_time';
export const MILESTONE_PROCEDURE_ANCHOR__END_TIME = 'procedure_end_time';

export const MILESTONE_PROCEDURE_ANCHOR__VALUES = [
  MILESTONE_PROCEDURE_ANCHOR__START_TIME,
  MILESTONE_PROCEDURE_ANCHOR__END_TIME,
];

export const MILESTONE_ENROLMENT_ANCHOR__ENROLMENT_DATE = 'enrolment_date';

export const MILESTONE_ENROLMENT_ANCHOR__VALUES = [
  MILESTONE_ENROLMENT_ANCHOR__ENROLMENT_DATE,
];

export const MILESTONE_ANCHOR__START_TIME = 'start_time';
export const MILESTONE_ANCHOR__END_TIME = 'end_time';
export const MILESTONE_ANCHOR__ENROLMENT_DATE = 'enrolment_date';

export const MILESTONE_ANCHOR__VALUES = [
  MILESTONE_ANCHOR__START_TIME,
  MILESTONE_ANCHOR__END_TIME,
  MILESTONE_ENROLMENT_ANCHOR__ENROLMENT_DATE,
];
